import React from 'react';
import './WeatherQuick.css';
import Isvg from 'react-inlinesvg';


const propTypes = {
  currentTemperature: React.PropTypes.string.isRequired,
  hourlyData: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
  suggestedClothing: React.PropTypes.array.isRequired,
}

const WeatherQuick = props => (
  <div className='weather-quick'>
    <div className='weather-quick__clothing'>
      {props.suggestedClothing.map(clothingItem => (
        <div
          className='weather-quick__clothing-item'
          key={`weather-quick-clothing-${clothingItem}`}>
          <Isvg
            src={`${process.env.PUBLIC_URL}/icons/clothing/${clothingItem}.svg`}
            cacheGetRequests={true}/>
        </div>
      ))}
    </div>
    <div className='weather-quick__current'>
      <div className='weather-quick__current-inner'>
        <span className='weather-quick__current-title'>Now:</span>
        <span className='weather-quick__current-temp'>{props.currentTemperature}</span>
      </div>
    </div>
    <div className='weather-quick__hourly'>
      {props.hourlyData.map(hourObj => (
        <div
          className='weather-quick__hour'
          key={`weather-quick-hour-${hourObj.time}`}>
          {hourObj.time}
          <Isvg
            src={`${process.env.PUBLIC_URL}/icons/weather/${hourObj.icon}.svg`}
            cacheGetRequests={true}/>
          {hourObj.temperature}
        </div>
      ))}
    </div>
  </div>
)

WeatherQuick.propTypes = propTypes;

export default WeatherQuick;



// WEBPACK FOOTER //
// ./src/components/WeatherQuick/WeatherQuick.js